@if (model.length > 0) {
  <ul class="layout-menu">
    @for (item of model; track item; let i = $index) {
      @if (!item.separator) {
        <li
          app-menuitem
          [item]="item"
          [index]="i"
          [root]="true"
        ></li>
      }
      @if (item.separator) {
        <li class="menu-separator"></li>
      }
    }
  </ul>
}

<!-- <input  type="file" id="miInputFile" (change)="processFile($event)" style="display: none;" /> -->
